// import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import dynamic from 'next/dynamic';
import useWindowSize from '@components/_hooks/useWindowSize';
import useProduct from '@components/_hooks/CSRHooks/useProduct';
import { getCanonicalSlug, isDefined, productLink } from '@components/config/helpers';
import OG from '../Reusables/OG';
import Products from '../Actions/ConfirmQuote/Products';

const PageHead = dynamic(() => import('../Reusables/PageHead'))
const ProductLoadingSkeleton = dynamic(() => import('./ProductLoadingSkeleton'))
const BoxContainer = dynamic(() => import('../Reusables/BoxContainerV2'))
const ProductContainer = dynamic(() => import('./ProductContainer'))
// const ProductSlider2 = dynamic(() => import('./ProductSlider2'))
const ProductSchema = dynamic(() => import('../Schemas/ProductSchema'))

const ProductV2 = ({ productData }) => {
    const { isMobile } = useWindowSize();

    const {
        localProductData,
        loadingProducts
    } = useProduct(productData);

    const {
        extras,
        product,
        //   product_price,
        addon_groups,
        long_term_product,
        price_breaks,
        new_price_breaks,
        //   long_term_hire_discount_rows,
        diameter,
        width,
        depth,
        height,
        long_term,
        measurements,
        key_features,
        videos,
        articles,
        reviews,
        faqs,
        product_variants,
        //   frequently_bought_together,
        related_products,
        product_extra_media,
        long_desc,
        //   defaults,
        template_page_settings,
        finishes,
    } = localProductData

    const canonical_link = process.env.brand.brand_id == 1 ? false : `${process.env.NEXT_PUBLIC_HOME_URL}/${localProductData?.canonical_link}`
    const urlLink = getCanonicalSlug({ canonical_category_slug: localProductData?.product?.canonical_category_slug, section_slug: localProductData?.product?.section_slug });

    return (
        <>
            <PageHead
                title={localProductData.product.product_meta_title}
                description={localProductData.product.product_meta_desc}
                keywords={localProductData.product.meta_keywords}
                link={canonical_link}
                ogTitle={localProductData.product.product_meta_title}
                ogType={"product"}
                ogUrl={`${process.env.BASE_URL}${productLink(urlLink, localProductData.product.product_slug, long_term)}`}
                ogImage={localProductData.product.image}
                ogDescription={localProductData.product.product_meta_desc}
                ogSiteName={process.env.brand.brand_name}
            />

            <BoxContainer id="product_page" className={(!isMobile && template_page_settings?.page_class_type ? template_page_settings?.page_class_type : 'pl-2 pr-2')}>
                <ProductSchema productData={localProductData} />

                {loadingProducts ? (
                    <ProductLoadingSkeleton />
                ) : (
                    <>
                        {localProductData && (
                            <>
                                <ProductContainer
                                    key={localProductData?.product?.product_slug}
                                    productData={localProductData}
                                    product_extra_media={product_extra_media}
                                    product={product}
                                    long_desc={long_desc}
                                    long_term_product={long_term_product}
                                    price_breaks={price_breaks}
                                    new_price_breaks={product?.new_price_breaks || []}
                                    diameter={diameter}
                                    width={width}
                                    depth={depth}
                                    height={height}
                                    measurements={measurements}
                                    articles={articles}
                                    faqs={faqs}
                                    videos={videos}
                                    product_variants={product_variants}
                                    reviews={reviews}
                                    key_features={key_features}
                                    addon_groups={addon_groups}
                                    related_products={related_products}
                                    long_term={long_term}
                                    template_page_settings={template_page_settings}
                                    finishes={finishes}
                                    product_finishes={product.finish_options}
                                    product_extras={product.extras}
                                    extras={extras}
                                />
                            </>
                        )}
                    </>
                )}
            </BoxContainer>
        </>
    )
}
export default ProductV2